import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Shared";

const Marquee = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="brand-marquee" className="border-y border-slate-100 bg-white py-10">
      <p className="mb-8 text-center text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400">
        {t.marquee.label}
      </p>
      <Reveal className="flex justify-center">
        <img
          src="/assets/wasabi-corner.png"
          alt="Wasabi Corner — Asian Street Food"
          data-testid="client-logo-wasabi"
          className="h-14 w-auto opacity-80 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0 sm:h-16"
        />
      </Reveal>
    </section>
  );
};

export default Marquee;
